import React, { useState } from "react";
import InputField from "~/lib/InputField";
import logo from "~/images/logos/watt-is.png";
import KeyIcon from "~/images/chave.svg?react";
import DeviseLayout from "./DeviseLayout";
import useCsrfToken from "~/hooks/useCsrfToken";
import useDeviseFeedback from "~/hooks/useDeviseFeedback";

const UnlockPage = () => {
  useDeviseFeedback({ successMessage: "Se a sua conta estiver bloqueada, receberá um e-mail com instruções de desbloqueio." });

  const [email, setEmail] = useState("");

  const csrfToken = useCsrfToken();

  return (
    <DeviseLayout>
      <form
        action="/users/unlock"
        method="post"
        className="flex flex-col lg:gap-8 gap-4"
      >
        <input
          type="hidden"
          value={csrfToken}
          name="authenticity_token"
          id="authenticity_token"
        />

        <div className="flex flex-col items-center mb-4">
          <img
            src={logo}
            alt="Watt-IS"
            className="w-40 h-auto mb-20"
          />
          <h2 className="lg:text-4xl text-xl font-normal text-center text-text-black">
            Desbloquear conta
          </h2>
        </div>

        <div className="flex flex-col gap-2 mx-8 lg:mx-20">
          <InputField
            id="email"
            label="Email"
            model={email}
            name="user[email]"
            onChange={setEmail}
            labelStyle="text-left text-sm font-medium text-text-soft-gray"
            inputStyle="focus:ring-2 focus:ring-text-soft-gray focus:outline-0 px-4 lg:py-3 py-2 border border-gray-400 bg-gray-100 rounded-2xl text-base"
          />
        </div>

        <div className="flex flex-col items-center gap-4 my-5 w-full">
          <button
            className="relative transition-all w-1/2 py-4 rounded-full bg-btn-tertiary hover:bg-btn-primary text-2xl text-white cursor-pointer flex items-center justify-center lg:block"
            type="submit"
            id="submit_button"
            name="submit_button"
          >
            <span className="text-center">Desbloquear</span>
            <KeyIcon className="w-6 h-6 ml-2 lg:ml-0 lg:absolute lg:right-10 lg:top-1/2 lg:-translate-y-1/2 fill-current text-white" />
          </button>

          <a
            href="/users/sign_in"
            className="transition-all w-1/2 py-4 rounded-full hover:bg-orange-sun bg-orange-600 text-2xl text-white text-center cursor-pointer"
          >
            Voltar
          </a>
        </div>
      </form>
    </DeviseLayout>
  );
};

export default UnlockPage;
